import { t } from 'i18next';
import { useMutation } from 'react-query';

import { addressService } from 'addresses/services';
import { ISaveAddressPayload } from 'addresses/types';
import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';

const useSaveAddress = (notificationPosition = NotificationPosition.DRAWER) => {
  const { errors } = useHandleErrors({
    success: ({ address }: ISaveAddressPayload) => ({
      message: address?.id ? t('messageAddressUpdateSuccess') : t('messageAddressCreateSuccess'),
    }),
    loading: ({ address }: ISaveAddressPayload) => ({
      message: address?.id
        ? t('messageAddressUpdateInProgress')
        : t('messageAddressCreateInProgress'),
    }),
    error: ({ address }: ISaveAddressPayload) => ({
      title: address?.id ? t('errorTitleAddressUpdate') : t('errorTitleAddressCreate'),
    }),
    position: notificationPosition,
  });

  const { mutateAsync } = useMutation(addressService.saveAddress, { ...errors });

  return { saveAddress: mutateAsync };
};

interface IAddressActionsProps {
  notificationPosition?: NotificationPosition;
}

export const useAddressActions = ({
  notificationPosition = NotificationPosition.DRAWER,
}: IAddressActionsProps = {}) => ({
  ...useSaveAddress(notificationPosition),
});
